import React from 'react'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { selectTermById } from '../../services/node/index'
import Link from '../Link/index'
import { getTopicGA4Data } from './utils'

/**
 * The topics card link component
 * @param {Object} props - The props
 * @param {String} props.language - The user's language
 * @param {Map} props.nodeTerm - The node term data
 * @returns {JSX.Element|null} Card link component
 */
const TopicsPageV3CardLink = (props) => {
  const { termData } = props
  const title = termData.get('title')
  const path = termData.get('path')
  const tid = termData.get('nid')
  const ga4TrackingData = getTopicGA4Data({ name: title, tid })

  if (!path) {
    return null
  }

  return (
    <Link
      to={path}
      className="topics-v3__card-link"
      ga4EventData={ga4TrackingData}
    >
      {title}
    </Link>
  )
}

export default compose(
  connectRedux(
    (state, props) => {
      const { contentId, language } = props
      const termData = selectTermById(state, { id: contentId, language, subPath: ['data'] })

      return { termData }
    },
  ),
)(TopicsPageV3CardLink)
